import React from "react";


export default class DirectoryPathItem extends React.Component {

    render() {
        return (
            <div onClick={this.props?.onClick} className="flexcc text-smaller white" style={{
                // fontSize: "small",
                padding: ".3rem .3rem",
                cursor: 'pointer'
            }}>
                {this.props.length === 1 ? '' :
                    (this.props?.path.length > 12 ? this.props?.path?.substr(0, 12) + '...' : this.props?.path)}
                <div
                    onClick={this.props?.onClick} >
                    {/* {this.props.path} */}
                </div>
            </div>
        )
    }
}